import { Form } from 'formik';

import styled from 'styled-components';

export const MainTitle = styled.div`
  font-size: 20px;
  margin-left: 15px;
  display: flex;
  margin-top: 13px;
  font: normal normal 600 18px/20px Biotif;
`;

export const EditIcon = styled.img`
  width: 15px;
  margin-left: 2rem;
`;

// Containers
export const Container = styled(Form)`
  display: flex;
  flex-direction: row;
  background: white;
  height: auto;
  width: auto;
  flex-wrap: nowrap;
  border-radius: 5px;
  min-height: 250px;
  padding-top: 1em;
  padding-bottom: 1em;
  @media only screen and (max-width: 1200px) {
    display: flex;
    flex-direction: column;
  }
`;

export const MailingAddress = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 50%;
  margin-right: 0.5em;
  @media only screen and (max-width: 1200px) {
    width: 100%;
  }
`;

export const EmploymentInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 40%;
  @media only screen and (max-width: 1200px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const FormTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 1.5em;
  align-items: center;
`;

export const FormTitleItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FormRow = styled.div`
  display: flex;
`;

export const MailingAddressFormContainer = styled.div`
  display: flex;
  margin-left: 1.5em;
  flex-wrap: wrap;
`;

export const FormInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  margin: 0.5em;
`;

export const SeparatorLine = styled.div`
  border-left: 2px solid #b6b4bd;
  height: 200px;
  align-self: center;
  @media only screen and (max-width: 1200px) {
    display: flex;
    width: 100%;
    border-left: 0;
    height: 10px;
    align-self: center;
    margin: 0.5em;
    border-top: 10px solid #f3f4f8;
  }
`;

export const SeparatorLineStraight = styled.div`
  min-height: 1.5px;
  background-color: #9399b247;
  margin-bottom: 20px;
`;
